import React from "react";
// import { GetProductApi } from "../../store/api/products";
// import { useDispatch, useSelector } from "react-redux";
// import { SpinnerDotted } from "spinners-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import coin from "../../assets/images/coin.png";
import { useSelector } from "react-redux";
import storage from "../../services/storage";
// import { calculateBonusCoins } from "../../services/number.services";

export default function ProductCard({
  products,
  loading,
  setLoading,
  giftcard,
}) {
  const navigate = useNavigate();
  const { promotion, eligibilityPromotion } = useSelector((state) => state.cart);
   const token = storage.get("xAuthToken");
 const promtionEnabled = useSelector((state) => state?.editUser?.user?.promotionsEnabled);
//  console.log('promotion Enabled:', promtionEnabled);
  const handleUnavailablePro = () => {
    toast.info("This Product has been Sold out");
  };
  return (
    <div>
      <div className="purchase_card_wrapper">
        {products?.map((item) => {
          return (
            <>
              <div key={item?._id} className="purchase_card_inner">
                <div
                  className="purchaseCard_img"
                  onClick={
                    // giftcard
                    //   ? () => navigate(`/gift-card-details/${item?._id}`)
                    //   :
                    item?.isAvailable === false
                      ? () => {}
                      : () => navigate(`/product-details/${item?._id}`)
                  }
                >
                  {token && promtionEnabled
                      ? eligibilityPromotion?.bonusPercentage && !giftcard && (
                          <div className="discount-tag">
                            <span>
                              {eligibilityPromotion?.bonusPercentage}
                              {eligibilityPromotion?.bonusType === "PERCENTAGE"
                                ? "% Bonus"
                                : "LDC Bonus"}
                            </span>
                          </div>
                        )
                      : promotion?.bonusPercentage && (
                          <div className="discount-tag">
                            <span>
                              {promotion?.bonusPercentage}
                              {promotion?.bonusType === "PERCENTAGE"
                                ? "% Bonus"
                                : "LDC Bonus"}
                            </span>
                          </div>
                        )}
               
                  <img
                    className={`${
                      item?.isAvailable === false ? "opac_imag" : ""
                    }`}
                    src={item?.image}
                    alt="purchase"
                    height={"250px"}
                    width={"auto"}
                  />
                </div>
                <div className="purchase_title">
                  <p>{item?.name}</p>
                </div>
                <div className="purchase_info">
                  <p>{item?.description}</p>
                </div>
                <div className="download_purchase_btn_wrapper download_btn_wrapper_products">
                  <div className="do">
                    <div className="product_price">
                      <p>${item?.price}</p>
                    </div>
                    <span className="coinbox2">
                      <img src={coin} alt="coin" />
                      {/* <p>{props?.itemId?.price * props?.quantity * coinRate}</p> */}
                      {/* updated secenrio */}
                      <p className="px-17" style={{ color: "#cbd8e7" }}>
                        {item?.coins}  
                        {/* {item?.coins} */}
                      </p>
                    </span>
                  </div>
                  <div className="product_buy">
                    <button
                      onClick={
                        // giftcard
                        //   ? () => navigate(`/gift-card-details/${item?._id}`)
                        //   :
                        item?.isAvailable === false
                          ? () => {}
                          : () => navigate(`/product-details/${item?._id}`)
                      }
                    >
                      {giftcard ? 'Buy' : item?.isAvailable === true ? "Buy" : "Sold"}
                    </button>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
}
